<template>
  <b-container class="tx_class">
    <b-row no-gutters style="justify-content: space-around;">
      <b-col cols=3 class="overflow-hidden"><span cols=1 style="color: blue; text-align: right; margin-right: 5px;">[Buy]</span><CurrencyAmount v-bind:amount="pays" /></b-col>
      <b-col cols=3 class="overflow-hidden"><span style="color: red; text-align: right; margin-right: 5px;">[Sell]</span><CurrencyAmount v-bind:amount="gets" /></b-col>
    </b-row>
  </b-container>
</template>

<script>
import CurrencyAmount from '../CurrencyAmount.vue'

var HasTx = require('../../mixins/has_tx')

export default {
  name   : 'OfferCreateTx',

  mixins : [HasTx],

  components : {
    CurrencyAmount
  },

  computed : {
    gets : function(){
      return this.tx_obj["TakerGets"];
    },

    pays : function(){
      return this.tx_obj["TakerPays"];
    }
  }
}
</script>

<style scoped>
</style>
